import { Typography } from "antd";
import classNames from "classnames";
import { Collapseable, KeyValueFormProps } from "components/UI/Collapseable/Collapseable.tsx";
import { ReactNode } from "react";
import "components/UI/DrawerCollapsible/overrides.css";

export interface DrawerCollapsibleProps extends Omit<KeyValueFormProps, "header" | "title"> {
    isDefaultOpen?: boolean;
    wrapperClassName?: string;
    title: ReactNode;
}

export const DrawerCollapsible = ({
    children,
    className,
    isDefaultOpen = true,
    title,
    ...restProps
}: DrawerCollapsibleProps) => {
    return (
        <Collapseable
            header={
                typeof title === "string" ? (
                    <Typography.Title className={"!m-0"} level={4}>
                        {title}
                    </Typography.Title>
                ) : (
                    <>{title}</>
                )
            }
            className={classNames("bg-white rounded-lg", className)}
            defaultActiveKey={isDefaultOpen ? ["1"] : []}
            {...restProps}
        >
            {children}
        </Collapseable>
    );
};
